import React from 'react';

const MyPassengersTotalizersHeaderItem = ({description, value}) => {
	return (
		<div className="my-passengers-totalizers-header-item">
			<div className="my-passengers-totalizers-header-item--description">
				{description}
			</div>
			<div className="my-passengers-totalizers-header-item--value">
				<strong> {value}</strong>
			</div>
		</div>
	);
};

export default MyPassengersTotalizersHeaderItem;